<button id="md-pesquisa-satisfacao" hidden (click)="isStartedSearch = exibirAvaliacao = true"></button>
<button id="show-evaluation" hidden (click)="exibirAvaliacao = false; exibirAgradecimento = true"></button>

@if (isStartedSearch) {
  <div class="suspended-overlay"></div>

  <div class="suspended-box" dataE2e="div-chat-box">

    <div class="satisfaction-header">
        <span>Pesquisa de satisfação</span>
        <button class="close-button" (click)="isStartedSearch = exibirAvaliacao = exibirAgradecimento = false; showFrame()"></button>
      </div>

    @if(exibirAvaliacao) {
      <div class="satisfaction-body">

        <p class="question">
          Como foi seu atendimento
          @if (isShowAgentName()) {
            com <strong>{{ agentName }}</strong>?
          }
          @else {
            ?
          }
        </p>
        <p class="subtext">
          Sua resposta nos ajuda a oferecer um atendimento cada vez melhor.
        </p>

        <div class="star-rating">
          <input type="radio" id="star5" name="rating" value="5">
          <label for="star5">&#9733;</label>
          <input type="radio" id="star4" name="rating" value="4">
          <label for="star4">&#9733;</label>
          <input type="radio" id="star3" name="rating" value="3">
          <label for="star3">&#9733;</label>
          <input type="radio" id="star2" name="rating" value="2">
          <label for="star2">&#9733;</label>
          <input type="radio" id="star1" name="rating" value="1" required>
          <label for="star1">&#9733;</label>
        </div>

        <div class="comment-box">
          <label for="comment" class="label">Quer deixar um elogio ou sugestão?</label>
          <textarea id="comment" placeholder="Escreva aqui (opcional)"></textarea>
        </div>

      </div>

      <div class="satisfaction-footer">
        <app-generic-button class="d-flex justify-content-end"
                            [description]="'Avaliar atendimento'"
                            [id-html]="'btn-modal-survey'"
                            [data-e2e]="'btn-modal-survey'"
                            [isBtnWithBorder]="true"
                            onclick="funEnviaPesquisa()">
        </app-generic-button>
      </div>
    }

    @if (exibirAgradecimento) {
      <div class="acknowledgment-body">

        <p class="acknowledgment-title">
          Obrigado por compartilhar sua opinião! 😀
        </p>

        <p class="acknowledgment-subtitle">
          Ela ajuda nosso time a melhorar o atendimento todos os dias.
        </p>

      </div>
    }

  </div>
}
